module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-container"
  }, [_h('div', {
    staticClass: "card three-times"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["施術内容"])]), " ", _h('div', {
    staticClass: "card-body center-column"
  }, [_h('div', {
    staticClass: "mgn-btm-3rem width-limit"
  }, [_h('h5', [_h('img', {
    attrs: {
      "src": "/images/title-shoulder.gif"
    }
  }), " 肩・首すじのコリは"]), " ", _h('p', ["肩から背中、首すじから後頭部とコリをていねいにほぐします"]), " ", _h('div', {
    staticClass: "mgn-btm-1rem"
  }, [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/neck-shoulder-1.jpg"
    }
  })]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/neck-shoulder-2.jpg"
    }
  })])]), " ", _h('div', {
    staticClass: "mgn-btm-3rem width-limit"
  }, [_h('h5', [_h('img', {
    attrs: {
      "src": "/images/title-chest.gif"
    }
  }), " 腰が重い　痛いときは"]), " ", _h('p', ["腰から足にかけての筋肉の疲れをゆっくりと時間をかけてほぐします"]), " ", _h('div', {
    staticClass: "mgn-btm-1rem"
  }, [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/chest-1.jpg"
    }
  })]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/chest-2.jpg"
    }
  })])]), " ", _h('div', {
    staticClass: "mgn-btm-3rem width-limit"
  }, [_h('h5', [_h('img', {
    attrs: {
      "src": "/images/title-neck.gif"
    }
  }), " 首から頭部や顔も"]), " ", _h('p', ["首すじをほぐすとリンパの流れもよくなり、老廃物が排除され、顔のむくみやたるみが取れます", _h('br'), "\n           頭部や顔の筋肉の血流をよくすることは、実はとても大切なことで、美容効果はもちろんですが、顔が疲れていると気持ちもふさぎ込んでしまいます"]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/neck-face.jpg"
    }
  })])]), " ", _h('div', {
    staticClass: "mgn-btm-3rem width-limit"
  }, [_h('h5', [_h('img', {
    attrs: {
      "src": "/images/title-upper.gif"
    }
  }), " きょうせい（肩関節と背骨の矯正）"]), " ", _h('p', ["腕から胸の筋肉を大きく伸ばし、胸を広げます。同時に、背中をそらすことで背骨が矯正されます。呼吸も楽になります。"]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/correction-2.jpg"
    }
  })])]), " ", _h('div', {
    staticClass: "mgn-btm-3rem width-limit"
  }, [_h('h5', [_h('img', {
    attrs: {
      "src": "/images/title-lower.gif"
    }
  }), " きょうせい（骨盤矯正）"]), " ", _h('p', ["骨盤を矯正することは、腰痛を改善するだけではなく、立っているとき、座っているときの姿勢も良くなり、さらに整腸作用にも効果があります。"]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/correction-1.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58718554!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/Treatment.vue
// module id = 433
// module chunks = 0